import axios from 'axios'

const BASE_URL = 'https://api.companieshouse.gov.uk'

async function getCompanyById(companyNumber: any) {
  const response = await axios({
    method: 'get',
    url: BASE_URL.concat(`/company/${companyNumber}`),
    auth: {
      username: 'cPv1-5OA0vwMiA06S4egkZbtoXy49rxfjKMP1H90',
      password: '',
    },
  })

  return response
}

export const companiesHouseAPI = {
  getCompanyById,
}
